// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectTeamMember  {
    _originalTypeClassName = "Loom.BO.ProjectTeamMember";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectTeamMember.translate = translateService;
}
this.Id = null;
this.FromMonth = null;
this.ToMonth = null;
this.MinHours = null;
this.MaxHours = null;
this.IsMemberRequired = false;
this.MainRole = null;
this.Percentage = null;
this.EstimatedPMs = null;
this.FromMonthDate = null;
this.ToMonthDate = null;
this.PersonHours = null;
this.PersonMonths = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
FromMonth:any;
ToMonth:any;
MinHours:any;
MaxHours:any;
IsMemberRequired:any;
MainRole:any;
Percentage:any;
EstimatedPMs:any;
FromMonthDate:any;
ToMonthDate:any;
PersonHours:any;
PersonMonths:any;
Employee:any;
ProjectParticipant:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removeProjectsMemberships(oldValue, $this);
}
Domain.Employee.addProjectsMemberships(value, $this);
}
}
static setProjectParticipant = ($this, value) => {
var oldValue = $this.ProjectParticipant;
$this.ProjectParticipant = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectParticipant.removeProjectTeam(oldValue, $this);
}
Domain.ProjectParticipant.addProjectTeam(value, $this);
}
}

static GetEstimatedPMs($this: any): any{return $this?.Percentage;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}